<template>
  <nav class="navbar navbar-expand-lg px-4 admin-navbar">
    <router-link class="navbar-brand d-flex align-items-center gap-2" to="/admin/dashboard">
      <span class="admin-badge-nav">ADMIN</span>
      <span class="brand-text">{{ appTitle }}</span>
    </router-link>

    <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#adminNavMenu">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="adminNavMenu">
      <ul class="navbar-nav me-auto ms-3">
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/users">사용자 관리</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/parking-area">주차장 관리</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/discount">할인 관리</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/common-setting">통합 설정</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/notices">공지사항</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/parking-pass-waiting">정기권 대기 관리</router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/parking-pass-change">정기권 교체 관리</router-link>
        </li> -->
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/ticket-winner">당첨자 결제 요청</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/lottery-loser">탈락자 관리</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/active-parking-pass">운영중 정기권</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/active-parking-pass-change-history">정기권 변경 이력</router-link>
        </li>
        
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/test-data-insert">테스트 데이터 생성</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/api-test">중계서버 API 테스트</router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/ebpp-test">EBPP 테스트</router-link>
        </li> -->
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/payment-result">결제 내역</router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/payment-cancel">카드 취소 내역</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/admin/payment-fail-result">결제 실패 내역</router-link>
        </li> -->
      </ul>
      <ul class="navbar-nav ms-auto align-items-center gap-2">
        <li class="nav-item" v-if="isLoggedIn">
          <span class="admin-name">{{ adminNameLocal }} 님</span>
        </li>
        <li class="nav-item" v-if="isLoggedIn">
          <button class="ef-logout-btn" @click="logout">로그아웃</button>
        </li>
        <li class="nav-item" v-else>
          <router-link class="ef-logout-btn" to="/admin/login">로그인</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AdminNavBar',
  computed: {
  },
  data() {
    return {
      adminNameLocal: '관리자',
      isLoggedIn: false,
      appTitle: process.env.VUE_APP_TITLE || 'EF Park'
    }
  },
  mounted() {
    this.refreshAuth()
    // bind the handler so `this` is preserved when called from window event
    this._onAdminAuthChanged = this.refreshAuth.bind(this)
    window.addEventListener('admin-auth-changed', this._onAdminAuthChanged)
    // Also watch route changes to refresh auth state
    this.$watch(() => this.$route.path, () => this.refreshAuth())
  },
  beforeUnmount() {
    if (this._onAdminAuthChanged) window.removeEventListener('admin-auth-changed', this._onAdminAuthChanged)
  },
  methods: {
    refreshAuth() {
      try {
        const user = JSON.parse(sessionStorage.getItem('adminUser') || '{}')
        this.adminNameLocal = user.name || '관리자'
        this.isLoggedIn = !!(user && user.UserSeq)
      } catch (e) {
        this.adminNameLocal = '관리자'
        this.isLoggedIn = false
      }
    },
    logout() {
      sessionStorage.removeItem('adminUser')
      try { window.dispatchEvent(new Event('admin-auth-changed')) } catch (e) { /* ignore */ }
      this.$router.push('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-navbar {
  background: linear-gradient(135deg, #1a1a2e 0%, #3a0a0a 100%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
  min-height: 62px;
}

.admin-badge-nav {
  background: #e63946;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 2px 7px;
  border-radius: 4px;
}

.brand-text {
  font-size: 1.2rem;
  font-weight: 700;
  color: #e0e0e0;
  letter-spacing: 1px;
}

.ef-nav-link {
  color: #b0bec5 !important;
  font-weight: 500;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
  text-decoration: none;
}

.ef-nav-link:hover,
.ef-nav-link.router-link-active {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.1);
}

.admin-name {
  color: #b0bec5;
  font-size: 0.9rem;
}

.ef-logout-btn {
  background: transparent;
  border: 1px solid #b0bec5;
  color: #b0bec5;
  padding: 0.3rem 0.9rem;
  border-radius: 20px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
}

.ef-logout-btn:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
  border-color: #fff;
}
</style>
